import reduxStore from "../../configureEnvStore";
import { fabric } from "fabric";
import { COLOR_TO_ANNOT, KEYBOARD_KEYS, MARKUP_LIVESTREAM_MIN_VERSION, SHAPE_THICKNESS, SHAPE_TYPE } from "../../constants/Constants";
import { UPLOAD_FILES_DATA } from "../../constants/UploadFilesConstants";
import { uploadMarkupRootScope } from "../../constants/MarkupConstants";
import UploadFileMarkupService from "../../services/UploadFileMarkupService/UploadFileMarkupService";
import {
    setClearMarkup,
    setIsShadowOrStroke,
    setRedoEnabled,
    setSavebtndisabled,
    setSelectedColorIndex,
    setSelectedFontSizeForShape,
    setSelectedThicknessForShape,
    setUndoEnabled,
} from "../../reducers/markup-reducer";
import arMarkupService from "../../services/MarkupService/arMarkupService";
import markupService from "../../services/MarkupService/markupService";

/**this will check markup anf LP feature on live stream , checks min supprted version of android app*/
export const isLiveStreamFeatureSupported = (userDetails) => {
    if (userDetails?.appVersion) {
        const streamingAppVersion = parseFloat(userDetails.appVersion.replace("Android App v", ""));
        return streamingAppVersion >= MARKUP_LIVESTREAM_MIN_VERSION;
    }
    return false;
};

export const generateRectangle = (rectangleFeatures) => {
    const { startX, startY, endX, endY, color, shapeType, strokeWidth, isShadow } = rectangleFeatures;
    const widthVar = Math.abs(endX - startX);
    const heightVar = Math.abs(endY - startY);
    let obj = {
        left: startX,
        top: startY,
        originX: "left",
        originY: "top",
        width: widthVar,
        height: heightVar,
        angle: 0,
        transparentCorners: false,
        hasControls: false,
        hasBorders: false,
        selectable: true,
        shape_type: shapeType,
        fill: "transparent",
        stroke: color,
        strokeWidth: strokeWidth,
    };
    if (shapeType == SHAPE_TYPE.BLUR) {
        // blur
        obj.fill = color;
    } else {
        // reactangle
        obj.fill = "transparent";
        obj.stroke = color;
        obj.strokeWidth = strokeWidth;
        obj.strokeLineJoin = "round"; //This is for rounded corner of rectangle
        if (isShadow) {
            obj.shadow = showShadow(isShadow); //To show shadow when isShadowAndStroke selected
        }
    }

    const rect = new fabric.Rect(obj);
    return rect;
};

export const generateTextbox = (textBoxFeatures) => {
    const { startX, startY, color, isShadowAndStroke, fontSize, defaultText, shapeType } = textBoxFeatures;

    let stroke = "transparent";
    let shadow = null;

    let strokeWidth = fontSize * 0.16;
    //Show shadow when isShadowAndStroke selected
    if (isShadowAndStroke) {
        shadow = showShadow(isShadowAndStroke);
        strokeWidth = fontSize * 0.28;
        stroke = color === "#FFFFFF" ? "black" : "white";
    }

    const textbox = new fabric.IText(defaultText, {
        left: startX,
        top: startY,
        stroke: stroke,
        strokeWidth: strokeWidth,
        shadow: shadow,
        strokeLineJoin: "round",
        paintFirst: "stroke", // stroke behind fill
        fontSize: arMarkupService.checkARMarkupIsOngoing() ? markupService.getFontSizeForArMarkup() : fontSize,
        fontWeight: "bold",
        fill: color,
        editingBorderColor: "white",
        fontFamily: "Arial",
        hasControls: false,
        width: 250,
        shape_type: shapeType,
        charSpacing: 20,
    });

    return textbox;
};

//Generate a New Arrow Shape
export const generateArrow = (arrowFeatures) => {
    let { fromx, fromy, tox, toy, color, strokeWidth, isShadow } = arrowFeatures;

    strokeWidth = strokeWidth / 2;

    const taringleWidth = 55.0;
    const roundRadius = strokeWidth / 2;
    const angle = Math.atan2(toy - fromy, tox - fromx);
    const headlen = 4.0 * strokeWidth; // arrow width
    const anglerad = (Math.PI * taringleWidth) / 150.0;

    const points = [
        {
            x: fromx,
            y: fromy,
        },
        {
            x: tox - (headlen / 4) * Math.cos(angle - anglerad / 2),
            y: toy - (headlen / 4) * Math.sin(angle - anglerad / 2),
        },
        {
            x: tox - headlen * Math.cos(angle - anglerad / 2),
            y: toy - headlen * Math.sin(angle - anglerad / 2),
        },
        {
            x: tox + roundRadius * Math.cos(angle), // tip
            y: toy + roundRadius * Math.sin(angle),
        },
        {
            x: tox - headlen * Math.cos(angle + anglerad / 2),
            y: toy - headlen * Math.sin(angle + anglerad / 2),
        },
        {
            x: tox - (headlen / 4) * Math.cos(angle + anglerad / 2),
            y: toy - (headlen / 4) * Math.sin(angle + anglerad / 2),
        },
    ];

    const arrowShape = new fabric.Polygon(points, {
        fill: color,
        stroke: color,
        strokeWidth: strokeWidth,
        strokeLineJoin: "round",
        paintFirst: "stroke",
        hasControls: false,
        hasBorders: false,
        shape_type: SHAPE_TYPE.ARROW,
    });

    if (isShadow) {
        const shadow = showShadow(isShadow);
        arrowShape.set("shadow", shadow);
    }

    return arrowShape;
};

// prevent a small size arrow based on selected thickness size
export const minimumArrowSize = (arrowThickness) => {
    let minimumArrowSize;
    if (Number(arrowThickness) >= 1 && Number(arrowThickness) <= 10) {
        minimumArrowSize = 15;
    } else if (Number(arrowThickness) >= 12 && Number(arrowThickness) <= 15) {
        minimumArrowSize = 35;
    } else if (Number(arrowThickness) >= 18 && Number(arrowThickness) <= 20) {
        minimumArrowSize = 45;
    }
    return minimumArrowSize;
};

export const showShadow = (isShadowAndStroke) => {
    let shadow = null;
    if (isShadowAndStroke) {
        shadow = new fabric.Shadow({
            blur: 2,
            offsetX: 0,
            offsetY: 2,
            affectStroke: true,
            color: "#000000",
        });
    }
    return shadow;
};

export const handleToSetBrush = () => {
    if (reduxStore.getState().markup.selectedShapeType === SHAPE_TYPE.FREEDRAW) {
        if (reduxStore.getState().markup.markupInprogress || reduxStore.getState().markup.markupLiveStream) {
            markupService.setFreeDrawingParam();
        } else {
            setFreeDrawBrush();
        }
    }
};

export const handleToShowShadowAndStroke = (e) => {
    const shadowChecked = e.target.checked;
    if (UPLOAD_FILES_DATA.selectedImageObj) {
        UPLOAD_FILES_DATA.selectedImageObj.isShadowOrStorke = shadowChecked;
    }
    reduxStore.dispatch(setIsShadowOrStroke(shadowChecked));
    handleToSetBrush();
};

export const setMarkupLineThickness = (selectedThickness) => {
    reduxStore.dispatch(setSelectedThicknessForShape(selectedThickness));
    if (UPLOAD_FILES_DATA.selectedImageObj) {
        UPLOAD_FILES_DATA.selectedImageObj.selectedThickness = selectedThickness;
    }
    handleToSetBrush();
};

export const setMarkupFontSize = (selectedFontSize) => {
    reduxStore.dispatch(setSelectedFontSizeForShape(selectedFontSize));
    if (UPLOAD_FILES_DATA.selectedImageObj) {
        UPLOAD_FILES_DATA.selectedImageObj.selectedFontSize = selectedFontSize;
    }
};

export const validateInput = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only numbers and control keys (e.g., backspace, delete, arrow keys)
    const isShiftPressed = event.shiftKey; // Check if Shift key is pressed
    // Array of valid key codes for numbers and control keys
    const validKeyCodes = [
        // Numbers: ASCII codes for digits 0 to 9
        ...Array.from({ length: 10 }, (_, i) => KEYBOARD_KEYS.NUMBER_MIN + i),
        // Control keys
        KEYBOARD_KEYS.BACKSPACE, // Backspace
        KEYBOARD_KEYS.TAB, // Tab
        KEYBOARD_KEYS.ENTER, // Enter
        KEYBOARD_KEYS.ESCAPE, // Escape
        KEYBOARD_KEYS.LEFT_ARROW, // Left arrow
        KEYBOARD_KEYS.UP_ARROW, // Up arrow
        KEYBOARD_KEYS.RIGHT_ARROW, // Right arrow
        KEYBOARD_KEYS.DOWN_ARROW, // Down arrow
    ];
    const isNumberKey = charCode >= KEYBOARD_KEYS.NUMBER_MIN && charCode <= KEYBOARD_KEYS.NUMBER_MAX;

    // Prevent if Shift is pressed along with a number key (special characters) or if it's not a valid key
    if ((isShiftPressed && isNumberKey) || !validKeyCodes.includes(charCode)) {
        event.preventDefault();
    }
};

export const onPasteValidate = (event) => {
    console.log("eventevent", event);
    const pastedData = event.clipboardData.getData("text/plain");
    // Validate the pasted data using a regular expression
    if (!/^\d+$/.test(pastedData)) {
        event.preventDefault();
    }
};

export const enableMarkupUndo = () => {
    reduxStore.dispatch(setUndoEnabled(true));
};
export const disableMarkupUndo = () => {
    reduxStore.dispatch(setUndoEnabled(false));
};

export const enableMarkupRedo = () => {
    reduxStore.dispatch(setRedoEnabled(true));
};
export const disableMarkupRedo = () => {
    reduxStore.dispatch(setRedoEnabled(false));
};

export const enableClearMarkup = () => {
    reduxStore.dispatch(setClearMarkup(true));
};
export const disableClearMarkup = () => {
    reduxStore.dispatch(setClearMarkup(false));
};

export const resetMarkupUndoList = () => {
    UPLOAD_FILES_DATA.selectedImageObj.undoList = [];
    disableMarkupRedo();
};

export const setFreeDrawBrush = () => {
    uploadMarkupRootScope.isResetted = false;
    let annCanvas = UPLOAD_FILES_DATA.annCanvas;
    if (annCanvas) {
        annCanvas.isDrawingMode = true;
        annCanvas.freeDrawingBrush.color = UPLOAD_FILES_DATA.selectedImageObj.anncolor;
        annCanvas.freeDrawingBrush.width = reduxStore.getState().markup.selectedThicknessForShape || SHAPE_THICKNESS[5]; // 10px
        annCanvas.selection = false;
        annCanvas.freeDrawingBrush.shadow = showShadow(reduxStore.getState().markup.isShadowOrStroke);
    }
};

export const checkIsTextBoxEmpty = (txtObj) => {
    let annCanvas = UPLOAD_FILES_DATA.annCanvas;
    if (txtObj.text != null && (txtObj.text.trim() == "" || txtObj.text.trim() == UploadFileMarkupService.markupVar.MarkupDefaultText)) {
        console.log("removing textobj=" + txtObj.id);
        annCanvas.remove(txtObj);
        annCanvas.renderAll();
        return true;
    } else {
        return false;
    }
};

export const addInShapeList = (obj) => {
    if (obj.shape_type == SHAPE_TYPE.TEXT && (uploadMarkupRootScope.isResetted || uploadMarkupRootScope.escape || checkIsTextBoxEmpty(obj))) {
        return false;
    }
    // Clone shapeList before modifying it
    const clonedShapeList = [...UPLOAD_FILES_DATA.selectedImageObj.shapeList];
    clonedShapeList.push(obj);
    // Now set the cloned array back to the selectedImageObj
    UPLOAD_FILES_DATA.selectedImageObj.shapeList = clonedShapeList;

    enableMarkupUndo();
    enableClearMarkup();
    //when new object is drawn, redo can not be done on earlier undone objects.so clear it.
    resetMarkupUndoList();
};

export const setFileColorByFill = (e) => {
    const colorIndex = e.target.value;
    reduxStore.dispatch(setSelectedColorIndex(parseInt(colorIndex)));
    if (UPLOAD_FILES_DATA.selectedImageObj) {
        UPLOAD_FILES_DATA.selectedImageObj.anncolor = COLOR_TO_ANNOT[colorIndex];
        UPLOAD_FILES_DATA.selectedImageObj.anncolorIndex = colorIndex;
    }

    if (reduxStore.getState().markup.selectedShapeType == SHAPE_TYPE.FREEDRAW) {
        if (
            reduxStore.getState().markup.markupInprogress ||
            reduxStore.getState().markup.markupLiveStream ||
            arMarkupService.checkARMarkupIsOngoing()
        ) {
            markupService.setFreeDrawingParam();
        } else {
            setFreeDrawBrush();
        }
    }
};

export const drawOnCanvas = (loadingFirstTime, selectedImageObj) => {
    fabric.Image.fromURL(selectedImageObj.src, (img) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (loadingFirstTime) {
            annCanvas = new fabric.Canvas("multiMarkupCanvas");
            annCanvas.isDrawingMode = false;
        }

        let oImg = null;
        if (img.width < 950) {
            annCanvas.setWidth(img.width);
            annCanvas.setHeight(img.height < 600 ? img.height : "600");

            oImg = img.set({
                width: img.width,
                centeredRotation: true,
                centeredScaling: true,
            });
        } else {
            img.set({
                centeredRotation: true,
                centeredScaling: true,
                backgroundImageStretch: false,
            });
            //// oImg = img.scaleToWidth("950"); do not remove commonted code as we don't why this scale is using
            oImg = img.scaleToWidth(img.width);
            console.log(oImg);
        }

        annCanvas.setWidth(img.width * oImg.scaleX);

        if (loadingFirstTime) {
            document.querySelector(".canvas-container")?.classList.add("canvas-image-container");
            document.querySelector(".lower-canvas")?.classList.add("canvas-image");
            document.querySelector(".upper-canvas")?.classList.add("canvas-image");
        }

        annCanvas.setHeight(img.height * oImg.scaleY);
        annCanvas.setBackgroundImage(oImg).renderAll();
        annCanvas.selection = false;
        if (selectedImageObj?.shapeList.length > 0) {
            selectedImageObj?.shapeList.map((shape) => {
                let parsedShape = shape;
                if (typeof shape === "string") {
                    parsedShape = UploadFileMarkupService.generateShapeFromObject(JSON.parse(shape));
                }

                annCanvas.add(parsedShape);
                return parsedShape;
            });
            UploadFileMarkupService.handleShapeCount(selectedImageObj?.shapeList.length);
            UploadFileMarkupService.deselectAllObj();
            enableClearMarkup();
            enableMarkupUndo();
        } else {
            disableMarkupUndo();
            disableClearMarkup();
        }
        if (selectedImageObj?.undoList.length > 0) {
            enableMarkupRedo();
        } else {
            disableMarkupRedo();
        }

        UPLOAD_FILES_DATA.annCanvas = annCanvas;
        if (UPLOAD_FILES_DATA.annCanvas && loadingFirstTime) {
            UploadFileMarkupService.selectShape(SHAPE_TYPE.FREEDRAW);
        }
        const selectedShapeType = reduxStore.getState().markup.selectedShapeType;
        if (selectedShapeType == SHAPE_TYPE.FREEDRAW) {
            setFreeDrawBrush();
            UploadFileMarkupService.selectShape(selectedShapeType);
        }
    });
};

export const enableSaveMarkup = () => {
    reduxStore.dispatch(setSavebtndisabled(false));
};

export const disableSaveMarkup = () => {
    reduxStore.dispatch(setSavebtndisabled(true));
};
